export default __webpack_public_path__ + "static/media/TNS-Web-Banners-Independent-Newspapers.1c3ca965.png";